import React from "react";
import { Button, RadioGroup, Card, CardContent, Divider, Fab, FormControl, FormControlLabel, MenuItem, Pagination, Radio, Stack, Switch, TextField, Grow, Grid, Autocomplete } from "@material-ui/core";
import {
  Typography,
  Box,
} from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { goToExpense, goToIncomes, goToLogin, goToUsers } from "../../../routes/Coordinator";
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import useForm from "../../../hooks/useForm";
import axios from "axios";
import { useEffect } from "react";
import { ptBR } from "date-fns/locale";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { format } from 'date-fns'
import { SelectProvider } from "./StyledOutflowRecord";
import Select from 'react-select'

function UseQuery() {
  return new URLSearchParams(window.location.search)
}

const optionList = [
  {
    value: "cashbook",
    label: "Livro Caixa",
  },
  {
    value: "income_tax",
    label: "Imposto de Renda",
  },
  {
    value: "cash_outflow",
    label: "Despesa Fluxo de Caixa",
  },
];
const OutflowRecord = () => {
  const { form, onChangeForm, clear } = useForm({
    release: "", doc_number: "", nature: "", option: "", value: "", description: "",
    patient_id: "", doctor_id: "", type_id: ""
  });
  const [release, setRelease] = useState(new Date())
  const [doc_number, setDocNumber] = useState("")
  const [nature, setNature] = useState("outflow")
  const [option, setOption] = useState("cashbook")
  const [value, setValue] = useState("")
  const [description, setDescription] = useState("")
  const [receipt, setReceipt] = useState(null)
  const [provider_id, setProviderId] = useState("")
  const [providers, setProviders] = useState([])
  const [doctor_id, setDoctorId] = useState("")
  const [doctors, setDoctors] = useState([])
  const [types, setTypes] = useState([])
  const [type_id, setTypeId] = useState("")
  const [installments, setInstallments] = useState(1)
  const [checked, setChecked] = useState(false);
  const [provider, setProvider] = useState({ name: "", id: null })
  const urlProviderId = UseQuery().get("provider_id")
  const urlProviderName = UseQuery().get("provider_name")

  const navigate = useNavigate();


  const icon = (

    <Box component="form"
      sx={{ width: "100%" }}
      noValidate
      autoComplete="off"

    >

      <TextField
        fullWidth
        name={"installments"}
        onChange={(e) => setInstallments(e.target.value)}
        value={installments}
        label={"Quantidade de Parcelas"}
        variant={"outlined"}
        type={"number"}
      />
    </Box>

  );

  const handleChange = () => {
    setChecked((prev) => !prev);
  };

  const save = () => {
    let id = UseQuery().get("id")

    if (!id) {
      newExpense()
    } else {
      EditExpense()
    }
  }

  const EditExpense = () => {
    let newvalue = value.replace(/\./g, "")
    newvalue = newvalue.replace(",", ".")
    let id = UseQuery().get("id")
    let url = `${process.env.REACT_APP_BASE_URL}/transactions/${id}`
    const formData = new FormData()
    let date = null;
    console.log(release)
    // if (typeof release === 'string') {
    //   date = new Date(`${release} 12:00:00`);
    // } else {
    //   date = new Date(`${release.year()}-${release.month() + 1}-${release.date()} 12:00:00`);
    // }
    formData.append("transaction[release]", new Date(release).toLocaleDateString("fr-CA"))
    formData.append("transaction[doc_number]", doc_number)
    formData.append("transaction[nature]", nature)
    formData.append("transaction[option]", option)
    formData.append("transaction[value]", newvalue)
    formData.append("transaction[description]", description)
    formData.append("transaction[provider_id]", provider_id)
    formData.append("transaction[doctor_id]", doctor_id)
    formData.append("transaction[type_id]", type_id)
    if (receipt) {
      formData.append("transaction[receipt]", receipt)
    }
    axios.put(url, formData,
      {
        headers: {
          "access-token": localStorage.getItem("access-token"),
          "client": localStorage.getItem("client"),
          "expiry": localStorage.getItem("expiry"),
          "token-type": localStorage.getItem("token-type"),
          "uid": localStorage.getItem("uid")
        }
      })
      .then(response => {
        goToExpense(navigate)
      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })
  }
  const newExpense = () => {
    let newvalue = value.replace(/\./g, "")
    newvalue = newvalue.replace(",", ".")
    const formData = new FormData()
    formData.append("transaction[release]", new Date(release).toLocaleDateString("fr-CA"))
    formData.append("transaction[doc_number]", doc_number)
    formData.append("transaction[nature]", nature)
    formData.append("transaction[option]", option)
    formData.append("transaction[value]", newvalue)
    formData.append("transaction[description]", description)
    formData.append("transaction[provider_id]", provider_id)
    formData.append("transaction[doctor_id]", doctor_id)
    formData.append("transaction[type_id]", type_id)
    formData.append("transaction[installments]", installments)
    formData.append("transaction[receipt]", receipt)
    axios.post(`${process.env.REACT_APP_BASE_URL}/transactions`, formData,
      {
        headers: {
          "access-token": localStorage.getItem("access-token"),
          "client": localStorage.getItem("client"),
          "token-type": localStorage.getItem("token-type"),
          "expiry": localStorage.getItem("expiry"),
          "uid": localStorage.getItem("uid")

        }
      })
      .then((resposta) => {
        alert("Despesa cadastrada com sucesso!")
        goToExpense(navigate)
      })
      .catch((erro) => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      }
      )

  }

  const filterType = (value) => {
    let url = `${process.env.REACT_APP_BASE_URL}/types?option=${value}&nature=outflow`

    axios.get(url, {
      params: { all: true },

      headers: {
        "access-token": localStorage.getItem("access-token"),
        "client": localStorage.getItem("client"),
        "expiry": localStorage.getItem("expiry"),
        "token-type": localStorage.getItem("token-type"),
        "uid": localStorage.getItem("uid"),
        "Content-Type": "application/json"
      }
    })
      .then(response => {
        setTypes(response.data.types)
      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })
  };

  const Provider = (id) => {
    let url = `${process.env.REACT_APP_BASE_URL}/providers/${id}`

    axios.get(url, {
      params: { all: true },

      headers: {
        "access-token": localStorage.getItem("access-token"),
        "client": localStorage.getItem("client"),
        "expiry": localStorage.getItem("expiry"),
        "token-type": localStorage.getItem("token-type"),
        "uid": localStorage.getItem("uid"),
        "Content-Type": "application/json"
      }
    })
      .then(response => {
        setProvider(response.data)

      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })
  }
  const Show = () => {
    let id = UseQuery().get("id")
    if (id) {
      let url = `${process.env.REACT_APP_BASE_URL}/transactions/${id}`

      axios.get(url,
        {
          headers: {
            "access-token": localStorage.getItem("access-token"),
            "client": localStorage.getItem("client"),
            "expiry": localStorage.getItem("expiry"),
            "token-type": localStorage.getItem("token-type"),
            "uid": localStorage.getItem("uid")
          }
        })
        .then(response => {

          setRelease(new Date(`${response.data.release} 12:00:00`))
          setProviderId(response.data.provider.id)
          setDocNumber(response.data.doc_number)
          setValue(response.data.value.toLocaleString("pt-br", { minimumFractionDigits: 2 }))
          setDescription(response.data.description)
          setDoctorId(response.data.doctor_id)
          setTypeId(response.data.type.id)
          Provider(response.data.provider.id)
          const optionreturn = { 'Livro Caixa': 'cashbook', 'Imposto de Renda': 'income_tax', 'Despesa Fluxo de Caixa': 'cash_outflow' }
          setOption(optionreturn[response.data.option])
          filterType(optionreturn[response.data.option])
        })
        .catch(erro => {
          Object.keys(erro.response.data).forEach((item) => {
            alert(erro.response.data[item]);
          });
        })
    } else {
      filterType(option)
    }
  }

  const Doctors = () => {
    let url = `${process.env.REACT_APP_BASE_URL}/doctors`

    axios.get(url, {
      params: { all: true, active: true },

      headers: {
        "access-token": localStorage.getItem("access-token"),
        "client": localStorage.getItem("client"),
        "expiry": localStorage.getItem("expiry"),
        "token-type": localStorage.getItem("token-type"),
        "uid": localStorage.getItem("uid"),
        "Content-Type": "application/json"
      }
    })
      .then(response => {
        setDoctors(response.data.doctors)

      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })
  }
  const Providers = () => {
    let url = `${process.env.REACT_APP_BASE_URL}/providers`

    axios.get(url, {
      params: { all: true, active: true },

      headers: {
        "access-token": localStorage.getItem("access-token"),
        "client": localStorage.getItem("client"),
        "expiry": localStorage.getItem("expiry"),
        "token-type": localStorage.getItem("token-type"),
        "uid": localStorage.getItem("uid"),
        "Content-Type": "application/json"
      }
    })
      .then(response => {
        let responseData = response.data.providers.map((provider) => {
          return { value: provider.id, label: provider.name }
        })
        setProviders(responseData)

      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })
  }
  const formatCurrency = (value) => {
    let newvalue = value.replace(",", "")
    newvalue = newvalue.replace(/\./g, "")
    let tam = newvalue.length;
    if ((tam > 2) && (tam <= 5)) newvalue = newvalue.substr(0, tam - 2) + "," + newvalue.substr(tam - 2, tam);
    if ((tam >= 6) && (tam <= 8)) newvalue = newvalue.substr(0, tam - 5) + "." + newvalue.substr(tam - 5, 3) + "," + newvalue.substr(tam - 2, tam);
    if ((tam >= 9) && (tam <= 11)) newvalue = newvalue.substr(0, tam - 8) + "." + newvalue.substr(tam - 8, 3) + "." + newvalue.substr(tam - 5, 3) + "," + newvalue.substr(tam - 2, tam);
    if ((tam >= 12) && (tam <= 14)) newvalue = newvalue.substr(0, tam - 11) + "." + newvalue.substr(tam - 11, 3) + "." + newvalue.substr(tam - 8, 3) + "." + newvalue.substr(tam - 5, 3) + "," + newvalue.substr(tam - 2, tam);
    if ((tam >= 15) && (tam <= 17)) newvalue = newvalue.substr(0, tam - 14) + "." + newvalue.substr(tam - 14, 3) + "." + newvalue.substr(tam - 11, 3) + "." + newvalue.substr(tam - 8, 3) + "." + newvalue.substr(tam - 5, 3) + "," + newvalue.substr(tam - 2, tam);
    setValue(newvalue)
  }
  useEffect(() => {
    Doctors()
    Providers()
    Show()
  }, [])

  return (
    <Box>
      <Card variant="outlined">
        <CardContent>
          <Typography variant="h3" sx={{ mb: 2 }}>Cadastrar Despesa</Typography>
          <Divider />
          <form>
            <CardContent
              sx={{
                padding: "30px",
              }}
            >
              <Grid container rowSpacing={2} columnSpacing={3}>
                <Grid item xs={12} md={6} lg={3}>
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                    <DatePicker
                      sx={{ width: "100%" }}
                      label={"Data de Lançamento"}
                      value={release}
                      onChange={(newDate) => {
                        setRelease(newDate);
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={12} md={6} lg={3} >
                  <TextField
                    fullWidth
                    select
                    label="Opção"
                    required
                    id="outlined-required"
                    onChange={(e) => {
                      filterType(e.target.value)
                      setOption(e.target.value)
                    }}
                    value={option}
                    type={"option"}
                    name="role"
                  >
                    {optionList.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} md={12} lg={6}>
                  <FormControl
                    sx={{ width: '100%' }}
                  >
                    <SelectProvider>
                      <Select
                        placeholder={"Fornecedor"}
                        options={providers}
                        defaultValue={urlProviderId ? { value: urlProviderId, label: urlProviderName } : null}
                        onChange={(e) => setProviderId(e.value)}
                      />
                    </SelectProvider>
                  </FormControl>
                  {/* <Autocomplete
                    disablePortal
                    placeholder={"Nenhum"}
                    // defaultValue={urlProviderId ? { value: urlProviderId, label: urlProviderName } : null}
                    options={providers}
                    onChange={(e, value) => setProviderId(value.value)}
                    fullWidth
                    renderInput={(params) => <TextField {...params} label="Fornecedor" />}
                  /> */}
                </Grid>
                <Grid item xs={12} md={12} lg={6}>
                  <TextField
                    fullWidth
                    label={"Número da Nota Fiscal"}
                    name={"doc_number"}
                    id="outlined-required"
                    onChange={(e) => setDocNumber(e.target.value)}
                    value={doc_number}
                    type={"doc_number"}
                  />
                </Grid>
                <Grid item xs={12} md={12} lg={6}>
                  <TextField
                    sx={{ position: 'sticky' }}
                    fullWidth
                    select
                    label="Tipo"
                    required
                    id="function"
                    onChange={(e) => setTypeId(e.target.value)}
                    value={type_id}
                    type={"type"}
                  >
                    {types.map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} md={12} lg={6}>
                  <TextField
                    fullWidth
                    required
                    select
                    label="Médico"
                    onChange={(e) => setDoctorId(e.target.value)}
                    value={doctor_id}
                    name={"doctor_id"}
                    type={"doctor_id"}
                  >
                    {doctors.map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} md={12} lg={6}>
                  <TextField
                    sx={{ position: 'sticky' }}
                    fullWidth
                    name={"value"}
                    required
                    id="outlined-required"
                    value={value}
                    label={"Valor"}
                    type={"text"}
                    onChange={(e) => formatCurrency(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} md={12} lg={6}>
                  <FormControl sx={{ width: "100%" }}>
                    <TextField
                      type="file"
                      onChange={(e) => setReceipt(e.target.files[0])}
                    />
                  </FormControl>
                  <Typography
                    sx={{ display: 'flex', justifyContent: 'flex-start' }}
                  >Recibo não pode ser maior que 1 MB</Typography>
                  {!UseQuery().get("id") &&
                    <Box >
                      <FormControlLabel
                        control={<Switch checked={checked} onChange={handleChange} />}
                        label="Repetir Parcelas"
                      />
                      <Box sx={{ display: 'flex' }}>

                        <Grow in={checked}>{icon}</Grow>

                      </Box>
                    </Box>
                  }
                </Grid>
                <Grid item xs={12} md={12} lg={6}>
                  <TextField
                    sx={{ position: 'sticky' }}
                    fullWidth
                    label={"Descrição"}
                    name={"description"}
                    id="outlined-required"
                    onChange={(e) => setDescription(e.target.value)}
                    value={description}
                    type={"description"}
                  />
                </Grid>
              </Grid>
            </CardContent>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end"
              }}
            >
              <Box>
                <Button onClick={save} variant="contained" color="success" startIcon={<AddIcon />}>
                  Salvar
                </Button>
                <Button onClick={() => goToExpense(navigate)} variant="outlined" startIcon={<ArrowBackIosIcon />}>
                  Voltar
                </Button>
              </Box>
            </Box>
          </form>
        </CardContent>
      </Card >
    </Box >
  );
};

export default OutflowRecord;